import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import {
  Row,
  Col,
  FormGroup,
  Radio,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import {
  getRoleNames,
  getOwnershipTypeName,
  getMemberNameByUserId,
  floatFormat,
  getRoleIds,
  getSubWorkTypeNameById,
} from '../../utils';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjust: undefined,
      changes: [],
      defaultRoleIds: [],
      selectedIndex: -1,
    };
  }

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }

    let defaultRoleIds = [];
    this.props.work.work_ownership_info.forEach(({ role_ids }) => {
      defaultRoleIds.push(role_ids);
    });
    this.setState({ defaultRoleIds });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { work } = this.props;

    if (
      !prevState.adjust &&
      this.state.adjust &&
      work &&
      work.work_ownership_info
    ) {
      work.work_ownership_info.forEach(({ id, ownership_type, percentage }) => {
        if (this.refs[`memberOwnership${id}`] && ownership_type) {
          findDOMNode(this.refs[`memberOwnership${id}`]).value = ownership_type;
        }
        this.setState({ [`memberSplit${id}`]: percentage ? percentage : 0 });
      });
    }

    if (
      this.state.changes.length &&
      !R.equals(this.state.changes, prevState.changes)
    ) {
      let { defaultRoleIds } = this.state;

      this.state.changes.forEach(
        ({ id, ownership_type, percentage, role_ids }) => {
          if (role_ids) {
            let index = _.findIndex(
              work.work_ownership_info,
              (info) => info.id === id
            );
            if (index !== -1) {
              defaultRoleIds[index] = role_ids;
            }
          }

          if (ownership_type && this.refs[`memberOwnership${id}`]) {
            findDOMNode(this.refs[`memberOwnership${id}`]).value =
              ownership_type;
          }
          if (percentage !== undefined) {
            this.setState({ [`memberSplit${id}`]: percentage });
          }
        }
      );
      this.setState({ defaultRoleIds });
    }
  }

  getLicenserIds() {
    const { contractBlocks, agreementContractBlocks } = this.props;

    const index = R.findIndex(R.propEq('name', 'Licensing Permissions'))(
      contractBlocks
    );
    if (index !== -1) {
      const block = R.find(
        R.propEq('contract_block', contractBlocks[index].id)
      )(agreementContractBlocks);
      if (block && block.options) {
        const options = JSON.parse(block.options);
        return options.licenserIds || [];
      }
    }

    return [];
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleSplit(e, id) {
    let state = this.state;
    state[`memberSplit${id}`] = e.target.value;
    this.setState({ state });
    this.validate(state);
  }

  validate(stateParam) {
    let state = stateParam ? stateParam : this.state;
    const { adjust, defaultRoleIds } = state;
    const { block, work } = this.props;
    let sum = 0;
    let checked = true;

    const roles = this.filterRoles();

    if (adjust && work && work.work_ownership_info) {
      const memberChanges = [];
      work.work_ownership_info.forEach((member, i) => {
        let changes = {};
        const memberRole = defaultRoleIds[i].filter((role) =>
          roles.find((item) => item.id === role)
        );

        let ownership_type = parseInt(
          findDOMNode(this.refs[`memberOwnership${member.id}`]).value,
          10
        );
        let percentage = state[`memberSplit${member.id}`]
          ? floatFormat(state[`memberSplit${member.id}`])
          : 0;
        percentage = parseFloat(percentage, 10);
        sum += percentage;

        changes.role_ids = memberRole;
        changes.ownership_type = ownership_type;
        changes.percentage = percentage;

        if (Object.keys(changes).length) {
          memberChanges.push({ ...changes, id: member.id });
        }
      });

      if (sum !== 100) {
        checked = false;
        this.props.setBlockChanges({
          id: block.id,
          options: memberChanges,
          checked: false,
          content: '',
        });
      } else {
        this.props.setBlockChanges({
          id: block.id,
          options: memberChanges,
          checked: true,
          content: '',
        });
      }
    } else {
      this.props.removeBlockChanges(block.id);
    }

    return checked;
  }

  handleNext = () => {
    if (this.validate(this.state)) {
      this.props.handleNext();
    } else {
      this.props.alert(
        'error',
        'Please make sure the ownership splits should be 100% as sum.'
      );
    }
  };

  renderOriginal() {
    const { work, roles, ownershipTypes, agreement, members } = this.props;

    if (agreement && work && work.work_ownership_info) {
      let licenserIds = this.getLicenserIds();

      const filteredRoles = R.filter(
        (role) => work.type === role.work_type,
        roles
      );

      return (
        <div className="ownership-splits">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Ownership Type</th>
                <th>Ownership Split</th>
              </tr>
            </thead>
            <tbody>
              {work.work_ownership_info.map((member, i) => (
                <tr key={i}>
                  <td>{getMemberNameByUserId(member.user, members)}</td>
                  <td>
                    <div className="default-role">
                      <div>
                        {getRoleNames(member.role_ids, filteredRoles).join(
                          ', '
                        )}
                      </div>
                    </div>
                  </td>
                  <td>
                    {getOwnershipTypeName(
                      member.ownership_type,
                      ownershipTypes
                    )}
                  </td>
                  {agreement.type === 'premium' &&
                  licenserIds.indexOf(member.user) !== -1 ? (
                    <td className="text-green">{member.percentage}%</td>
                  ) : (
                    <td>{member.percentage}%</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    } else {
      return null;
    }
  }

  getDefaultRoleOptions = (options, roelIds) => {
    let defaultRoleOptions = [];
    let defaultRoleArray = [];

    roelIds.forEach((roleId) => {
      const role = _.find(
        options,
        (option) => parseInt(option.value, 10) === roleId
      );
      if (role) {
        defaultRoleOptions.push(role);
        defaultRoleArray.push(role.label);
      }
    });

    return { defaultRoleOptions, defaultRoleArray };
  };

  handleSelectChange = (options, memberId) => {
    const roleIds = getRoleIds(options);

    let { defaultRoleIds } = this.state;
    let index = _.findIndex(
      this.props.work.work_ownership_info,
      (info) => info.id === memberId
    );
    if (index !== -1) {
      defaultRoleIds[index] = roleIds;
    }

    this.setState({ defaultRoleIds, selectedIndex: -1 }, () => {
      this.validate();
    });
  };

  filterRoles = () => {
    let { roles, work } = this.props;
    roles = R.filter((role) => work.type === role.work_type, roles);
    return R.sortBy(R.prop('title'), roles);
  };

  renderAdjust() {
    let { work, agreement, members, ownershipTypes, subWorkTypes } = this.props;

    if (work && agreement && work.work_ownership_info) {
      let sum = 0;

      let roles = this.filterRoles();
      ownershipTypes = R.filter(
        (o) => !o.work_type || work.type === o.work_type,
        ownershipTypes
      );

      if (work.sub_type) {
        const subWorkTypeName = getSubWorkTypeNameById(
          work.sub_type,
          subWorkTypes
        );

        if (subWorkTypeName === 'Sound Recording') {
          ownershipTypes = R.filter(
            (o) => o.name !== 'Musical Composition',
            ownershipTypes
          );
        } else {
          ownershipTypes = R.filter(
            (o) => o.name !== 'Sound Recording',
            ownershipTypes
          );
        }
      }

      let roleOptions = [];
      roles.forEach((role) => {
        roleOptions.push({ value: role.id, label: role.title });
      });

      return (
        <div className="ownership-splits">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Ownership Type</th>
                <th>Ownership Split</th>
              </tr>
            </thead>
            <tbody>
              {work.work_ownership_info.map((member, i) => {
                let percentage = this.state[`memberSplit${member.id}`]
                  ? this.state[`memberSplit${member.id}`]
                  : 0;
                sum += parseFloat(floatFormat(percentage), 10);

                let { defaultRoleOptions, defaultRoleArray } =
                  this.getDefaultRoleOptions(
                    roleOptions,
                    this.state.defaultRoleIds[i]
                  );

                return (
                  <tr key={i}>
                    <td>{getMemberNameByUserId(member.user, members)}</td>
                    <td>
                      {this.state.selectedIndex === i ? (
                        <Select
                          isMulti
                          value={defaultRoleOptions}
                          options={roleOptions}
                          placeholder="Select role(s)"
                          onChange={(options) =>
                            this.handleSelectChange(options, member.id)
                          }
                        />
                      ) : defaultRoleArray.length > 0 ? (
                        <OverlayTrigger
                          overlay={
                            <Tooltip id="tooltip-split">
                              <span>
                                {defaultRoleArray.join(', ') ||
                                  'Select Role(s)'}
                              </span>
                            </Tooltip>
                          }
                          placement="top"
                        >
                          <div
                            className="default-role change text-blue"
                            onClick={() => this.setState({ selectedIndex: i })}
                          >
                            <div>{defaultRoleArray.join(', ')}</div>
                          </div>
                        </OverlayTrigger>
                      ) : (
                        <Select
                          isMulti
                          value={defaultRoleOptions}
                          options={roleOptions}
                          placeholder="Select role(s)"
                          onChange={(options) =>
                            this.handleSelectChange(options, member.id)
                          }
                        />
                      )}
                    </td>
                    <td>
                      <select
                        ref={`memberOwnership${member.id}`}
                        onChange={(e) => this.validate()}
                      >
                        {ownershipTypes &&
                          ownershipTypes.map((ownershipType, i) => {
                            return (
                              <option key={i} value={ownershipType.id}>
                                {ownershipType.name}
                              </option>
                            );
                          })}
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={percentage}
                        onChange={(e) => this.handleSplit(e, member.id)}
                      />{' '}
                      %
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan={3}></td>
                <td>
                  Total:&nbsp;
                  <span
                    className={`${sum === 100 && 'text-green'} ${
                      sum < 100 && 'text-gray'
                    } ${sum > 100 && 'text-red'}`}
                  >
                    {sum}%
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { work, roles, ownershipTypes, members } = this.props;
    let content = '';
    if (changeRequest.changes && work && work.work_ownership_info) {
      changeRequest.changes.forEach(
        ({ id, role_ids, ownership_type, percentage }) => {
          const index = R.findIndex(R.propEq('id', id))(
            work.work_ownership_info
          );
          if (index !== -1) {
            if (content === '') {
              content = `<span class="text-red">${getMemberNameByUserId(
                work.work_ownership_info[index].user,
                members
              )}`;
            } else {
              content += `, and <span class="text-red">${getMemberNameByUserId(
                work.work_ownership_info[index].user,
                members
              )}`;
            }

            if (role_ids && role_ids.length > 0) {
              content += ` role to ${getRoleNames(role_ids, roles).join(
                ', '
              )},`;
            }
            if (ownership_type) {
              content += ` ownership type to ${getOwnershipTypeName(
                ownership_type,
                ownershipTypes
              )},`;
            }
            if (percentage !== undefined) {
              content += ` ownership split to ${percentage}%`;
            }
            content += `</span>`;
          }
        }
      );
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <div className="questions">
                <p className="question">
                  What is the ownership structure that you want to finalize?
                </p>
                <FormGroup className="answer">
                  <Row>
                    <Col sm={6}>
                      <Radio
                        name="overview-adjust"
                        checked={this.state.adjust === false}
                        readOnly
                        onClick={(e) => this.handleAdjust(false)}
                      >
                        {this.props.userInfo.same
                          ? `Keep my original proposal:`
                          : `Accept ${this.props.userInfo.name} 's proposed terms:`}
                      </Radio>
                    </Col>
                    <Col sm={6}>
                      <Radio
                        name="overview-adjust"
                        checked={this.state.adjust === true}
                        readOnly
                        onClick={(e) => this.handleAdjust(true)}
                      >
                        {this.props.userInfo.same
                          ? `Change my proposal:`
                          : `Suggest an alternative:`}
                      </Radio>
                    </Col>
                  </Row>
                </FormGroup>
                {this.state.adjust === true
                  ? this.renderAdjust()
                  : this.renderOriginal()}
                {this.props.renderAccepts()}
                {this.renderChangeRequests()}
              </div>
            </Col>
          )}

          {!this.props.finalized &&
            this.props.showNav &&
            !this.props.isAttorney && (
              <Col sm={12}>
                <div className="nav">
                  <button onClick={this.handleNext} className="button-continue">
                    Continue
                  </button>
                </div>
              </Col>
            )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <p className="small">
                A "split" is the percentage of the copyright(s) that each
                collaborator will own. To propose a split that is different than
                what is displayed, click on "propose an alternative" and enter a
                new number in the text box. <br />
                <br />
                {this.props.agreement &&
                this.props.agreement.type === 'premium' &&
                !this.props.work.additional
                  ? 'Click on "Continue" to save your changes.'
                  : null}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Overview.jsx